var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1270_3407)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0.5C5.241 0.5 0 5.453 0 12.14C0 15.638 1.434 18.662 3.768 20.75C3.963 20.924 4.083 21.17 4.089 21.434L4.155 23.57C4.15981 23.7272 4.20314 23.8807 4.2812 24.0172C4.35926 24.1537 4.46965 24.269 4.60267 24.3528C4.73569 24.4366 4.88726 24.4865 5.04408 24.4981C5.20089 24.5096 5.35814 24.4825 5.502 24.419L7.884 23.369C8.085 23.279 8.313 23.264 8.526 23.321C9.621 23.621 10.785 23.783 12 23.783C18.759 23.783 24 18.83 24 12.143C24 5.456 18.759 0.5 12 0.5Z",
  fill: "url(#paint0_radial_1270_3407)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.79413 15.5451L8.31913 9.95309C8.45174 9.74256 8.62655 9.5618 8.83254 9.42223C9.03853 9.28267 9.27121 9.18732 9.5159 9.14222C9.7606 9.09711 10.012 9.10323 10.2542 9.16018C10.4964 9.21713 10.7242 9.32368 10.9231 9.47309L13.7281 11.5761C13.8534 11.6698 14.0057 11.7203 14.1621 11.7197C14.3186 11.7192 14.4706 11.6677 14.5951 11.5731L18.3811 8.69909C18.8851 8.31509 19.5451 8.92109 19.2091 9.45809L15.6811 15.0471C15.5485 15.2576 15.3737 15.4384 15.1677 15.578C14.9617 15.7175 14.7291 15.8129 14.4844 15.858C14.2397 15.9031 13.9883 15.897 13.7461 15.84C13.5039 15.7831 13.2761 15.6765 13.0771 15.5271L10.2721 13.4241C10.1469 13.3303 9.99456 13.2799 9.83813 13.2805C9.6817 13.281 9.52971 13.3325 9.40513 13.4271L5.61913 16.3011C5.11513 16.6851 4.45513 16.0821 4.79413 15.5451Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_1270_3407",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.02 24.5) scale(26.4)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0099FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#A033FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#FF5280"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7061"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1270_3407"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.7f8c2345223b2713c7a8d6d2d108918d.svg";
export { ForwardRef as ReactComponent };